const Panel = ({children}) => {
    return <div className='bg-white shadow-sm rounded p-4 mt-3'>{children}</div>
}
export default Panel;